const isContentBlocked = (parentalRating, parentalLockConfig) => {
    const { enabled, rating, lockUnratedContent, unlocked } = parentalLockConfig;

    // if parental control is not enabled - show content
    if (!enabled) {
        return false;
    }

    // if control is enabled but unlocked - show content
    if (unlocked) {
        return false;
    }

    // If parental rating is defined in the item
    if (parentalRating) {
        let parentalLevel;
        // If parental rating is an object, parse level from value
        if (typeof parentalRating === 'object' && parentalRating.constructor === Object) {
            parentalLevel = parseInt(parentalRating.value, 10);
        }

        // If it is just a number, take it as level
        if (typeof parentalRating === 'number') {
            parentalLevel = parentalRating;
            // if its string we try to parse it into a number
        } else if (typeof parentalRating === 'string') {
            const matchNumber = parentalRating.match(/\d+/g);
            if (matchNumber) {
                parentalLevel = Number(matchNumber[0]);
            }
        }

        // if there is no value
        if (!parentalLevel || Number.isNaN(parentalLevel)) {
            // Return block unknown value
            return lockUnratedContent;
        }

        const ratingNumber = Number(rating);
        // If rating could not be parsed as number, allow content
        // this situation is possible on mCore
        if (Number.isNaN(ratingNumber)) {
            return false;
        }
        // if rating is -1 - allow all,
        // otherwise lock content that has higher level then lock
        return ratingNumber !== -1 && ratingNumber <= parentalLevel;
    }

    // Return block unknown value
    return lockUnratedContent;
};

const isContentLocked = (adult, parentalLockConfig) => {
    const { enabled, lockAdultContent, unlocked } = parentalLockConfig;

    // if parental control is not enabled - show content
    if (!enabled) {
        return false;
    }

    // if control is enabled but unlocked - show content
    if (unlocked) {
        return false;
    }

    // If adult blocking is set and adult flag is true - block this item
    return lockAdultContent && adult;
};

const isContentHidden = (adult, parentalLockConfig) => {
    if (!adult) {
        return false;
    }
    const { enabled, hideAdultChannels, unlocked } = parentalLockConfig;

    return enabled && !unlocked && hideAdultChannels;
};

const filterOutAdultItemsByCategories = (items, categories, parentalLockConfig) => {
    const { enabled, unlocked, hideAdultChannels } = parentalLockConfig;

    if (!categories || categories.length === 0) {
        return items;
    }

    if (!enabled) {
        return items;
    }

    if (unlocked) {
        return items;
    }

    if (!hideAdultChannels) {
        return items;
    }

    const filtered = [];
    const adultCategories = categories.find((cat) => cat.adult);

    // If there are not adult categories, there is nothing to filter
    if (!adultCategories) {
        return items;
    }

    items.forEach((item) => {
        const adultMatch = adultCategories.channels.find(
            (channel) => channel.channelId === item.getChannelId()
        );
        if (!adultMatch) {
            filtered.push(item);
        }
    });

    return filtered;
};

const getParentalRatingByModel = (item) => {
    const parentalStandard = item.data?.parentalRating;
    const parentalRecording =
        item.metaData?.detail?.schedule?.program?.programValue?.parentalRating;
    const parentalRecordingSeries =
        item.metadata?.metaData?.detail?.schedule?.program?.programValue?.parentalRating;
    const parentalFromSearch = item.data?.data?.parentalRating;

    return parentalStandard || parentalRecording || parentalRecordingSeries || parentalFromSearch;
};

const isAdult = (item) => item.metaData?.detail?.schedule?.program?.programValue?.ao;

export {
    isContentBlocked,
    isContentLocked,
    isContentHidden,
    filterOutAdultItemsByCategories,
    getParentalRatingByModel,
    isAdult
};
